/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtUpdateRewardFunder = {
  pool: Address;
  rewardIndex: number;
  oldFunder: Address;
  newFunder: Address;
};

export type EvtUpdateRewardFunderArgs = EvtUpdateRewardFunder;

export function getEvtUpdateRewardFunderEncoder(): FixedSizeEncoder<EvtUpdateRewardFunderArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["rewardIndex", getU8Encoder()],
    ["oldFunder", getAddressEncoder()],
    ["newFunder", getAddressEncoder()],
  ]);
}

export function getEvtUpdateRewardFunderDecoder(): FixedSizeDecoder<EvtUpdateRewardFunder> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["rewardIndex", getU8Decoder()],
    ["oldFunder", getAddressDecoder()],
    ["newFunder", getAddressDecoder()],
  ]);
}

export function getEvtUpdateRewardFunderCodec(): FixedSizeCodec<
  EvtUpdateRewardFunderArgs,
  EvtUpdateRewardFunder
> {
  return combineCodec(
    getEvtUpdateRewardFunderEncoder(),
    getEvtUpdateRewardFunderDecoder(),
  );
}
